import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "Welcome",
      component: () =>
        import(/* webpackChunkName: "Principal" */ "./views/Principal.vue"),
    },
    {
      path: "/:plantel/inicio",
      name: "inicio_link",
      component: () =>
        import(/* webpackChunkName: "Home" */ "./views/Home.vue"),
    },
    {
      path: "/inicio",
      name: "inicio",
      component: () =>
        import(/* webpackChunkName: "Home" */ "./views/Home.vue"),
    },
    {
      path: "/:plantel/carta-director",
      name: "carta-director",
      component: () =>
        import(
          /* webpackChunkName: "CardPrincipal" */ "./views/CardPrincipal.vue"
        ),
    },
    {
      path: "/:plantel/ubicacion",
      name: "ubicacion",
      component: () =>
        import(/* webpackChunkName: "Location" */ "./views/Location.vue"),
    },
    {
      path: "/informes",
      name: "informes",
      component: () =>
        import(/* webpackChunkName: "Information" */ "./views/Information.vue"),
    },
    {
      path: "/:plantel/informes",
      name: "informesPlantel",
      component: () =>
        import(
          /* webpackChunkName: "InformationPlantel" */ "./views/Information.vue"
        ),
    },
    {
      path: "/:plantel/eventos",
      name: "eventos",
      component: () =>
        import(/* webpackChunkName: "Articulos" */ "./views/Articulos.vue"),
    },
    {
      path: "/:plantel/preescolar",
      name: "preescolar",
      component: () =>
        import(/* webpackChunkName: "Preescolar" */ "./views/Preescolar.vue"),
    },
    {
      path: "/:plantel/primaria",
      name: "primaria",
      component: () =>
        import(/* webpackChunkName: "Primaria" */ "./views/Primaria.vue"),
    },
    {
      path: "/:plantel/secundaria",
      name: "secundaria",
      component: () =>
        import(/* webpackChunkName: "Secundaria" */ "./views/Secundaria.vue"),
    },
    {
      path: "/:plantel/preparatoria",
      name: "preparatoria",
      component: () =>
        import(
          /* webpackChunkName: "Preparatoria" */ "./views/Preparatoria.vue"
        ),
    },
    {
      path: "/:plantel/sistema",
      name: "sistema",
      component: () =>
        import(/* webpackChunkName: "System" */ "./views/System.vue"),
    },
    {
      path: "/:plantel/rapaces",
      name: "rapaces",
      component: () =>
        import(/* webpackChunkName: "Rapaces" */ "./views/Rapaces.vue"),
    },
    {
      path: "/inscripciones",
      name: "inscripciones",
      component: () =>
        import(/* webpackChunkName: "DescubreV" */ "./views/DescubreV.vue"),
    },
    {
      path: "/:campus/quejas-y-sugerencias",
      name: "Quejas",
      component: () => import("./views/Quejas.vue"),
    },
    {
      path: "/:campus/national-geographic",
      name: "National",
      component: () =>
        import(
          /* webpackChunkName: "NationalGeographic" */ "./views/NationalGeographic.vue"
        ),
    },
    {
      path: "/:campus/aviso_de_privacidad",
      name: "Aviso",
      component: () =>
        import(/* webpackChunkName: "Aviso" */ "./views/Aviso.vue"),
    },
    {
      path: "/:campus/enamorate",
      name: "Enamorate",
      component: () =>
        import(/* webpackChunkName: "Enamorate" */ "./views/Enamorate.vue"),
    },
    {
      path: "/gracias-informes",
      name: "gracias-informes",
      component: () =>
        import(/* webpackChunkName: "Thankyou" */ "./views/Thankyou.vue"),
    },
    {
      path: "/colaboradores",
      name: "Colaboradores",
      component: () =>
        import(/* webpackChunkName: "Thankyou" */ "./views/Collaborator.vue"),
    },
    {
      path: "/gracias-citas",
      name: "gracias-citas",
      component: () =>
        import(/* webpackChunkName: "Thankyou" */ "./views/Thankyou.vue"),
    },
    {
      path: "*",
      redirect: "/",
    },
  ],
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 };
  },
});
